"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("../style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _circleSmall = _interopRequireDefault(require("cccisd-icons/circle-small"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark3"));
require("react-dates/initialize");
require("./datePicker.scss");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CalendarDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(CalendarDialog, _React$Component);
  var _super = _createSuper(CalendarDialog);
  function CalendarDialog(props) {
    var _this;
    _classCallCheck(this, CalendarDialog);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "changeSessionHeld", function (held) {
      _this.props.changeSessionHeld(held);
    });
    _defineProperty(_assertThisInitialized(_this), "onDateSelect", function (date) {
      _this.setState({
        date: date.startDate
      });
      _this.props.onDateSelect(date);
    });
    _this.state = {
      date: {}
    };
    return _this;
  }
  _createClass(CalendarDialog, [{
    key: "render",
    value: function render() {
      var disabled = true;
      if (this.props.sessionHeld === false || this.props.sessionHeld === true && (0, _isEmpty2["default"])(this.state.date) || this.props.sessionHeld === true && !this.state.date.isAfter((0, _moment["default"])(), 'day')) {
        disabled = false;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: '4rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          margin: '0 6rem 0 6rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          // padding: '0 12rem 0 12rem',
          width: '25%'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '6px 8px',
          width: '100%'
        },
        className: (0, _classnames["default"])('btn btn-default', {
          active: this.props.sessionHeld
        }),
        onClick: this.changeSessionHeld.bind(null, true)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].held
      }, /*#__PURE__*/_react["default"].createElement(_circleSmall["default"], null)), "Held"), /*#__PURE__*/_react["default"].createElement("div", null, "-- OR --"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '6px 8px',
          width: '100%'
        },
        className: (0, _classnames["default"])('btn btn-default', {
          active: this.props.sessionHeld === false
        }),
        onClick: this.changeSessionHeld.bind(null, false)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].missed
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Missed")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          border: '1px solid lightgrey',
          width: '1px'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('data-collection-calendar', _style["default"].calendarPicker)
      }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerRangeController, {
        startDate: this.props.selectedDate,
        endDate: this.props.selectedDate // momentPropTypes.momentObj or null,
        ,

        onDatesChange: this.onDateSelect // momentPropTypes.momentObj or null,
        ,

        focusedInput: "startDate",
        hideKeyboardShortcutsPanel: true
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '3rem',
          marginRight: '12%',
          position: 'relative'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '318px',
          textAlign: 'right'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        style: {
          padding: '0.5rem 2rem 0.5rem 2rem'
        },
        className: "btn btn-primary",
        onClick: this.props.onCalendarSubmit,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null), " OK"), this.props.sessionHeld === true && !(0, _isEmpty2["default"])(this.state.date) && this.state.date.isAfter((0, _moment["default"])(), 'day') && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: '#a94442',
          fontSize: '0.9em'
        }
      }, "* Cannot hold session in the future"))));
    }
  }]);
  return CalendarDialog;
}(_react["default"].Component);
exports["default"] = CalendarDialog;
_defineProperty(CalendarDialog, "propTypes", {
  changeSessionHeld: _propTypes["default"].func,
  sessionHeld: _propTypes["default"].bool,
  selectedDate: _propTypes["default"].object,
  onDateSelect: _propTypes["default"].func,
  onCalendarSubmit: _propTypes["default"].func,
  notSubmitted: _propTypes["default"].bool,
  label: _propTypes["default"].string
});
_defineProperty(CalendarDialog, "defaultProps", {
  label: 'Session'
});